import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Divider, Grid, Stack } from '@mui/material';

import useStylesForm from 'common/components/styles/useStylesForm.styles';
import getSymbolFromCurrency from 'currency-symbol-map';
import { useEffect, useState } from 'react';
import useStylesProductForm from '../styles/useStylesProductForm.styles';
import ProductFormVariants from './ProductFormVariants';

import useFlexBoxStyles from 'common/flexBox';
import { NumericFormat } from 'react-number-format';
import ProductBroken from '../component/ProductBroken';

const ProductFormVariantsRow = (props) => {
    const {
        variant,
        variants,
        setVariants,
        deleteVariant,
        options,
        openForm,
        index,
        editingVariantIndex,
        readOnly,
        formConfigProductVariant,
        canEdit,
    } = props;

    const { classes: classes1 } = useStylesForm();
    const { classes: flexBox } = useFlexBoxStyles();
    const { classes: classes2, cx } = useStylesProductForm();
    const classes = { ...classes1, ...classes2 };

    const [showForm, setShowForm] = useState(false);

    useEffect(() => {
        if (index !== editingVariantIndex) {
            setShowForm(false);
        } else if (editingVariantIndex === index || editingVariantIndex === -1) {
            setShowForm(true);
        }
    }, [editingVariantIndex, index]);

    return (
        <div key={index} className={classes.variantContent}>
            <div key={variant.url} className={showForm ? classes.editVariant : ''}>
                <div className={classes.p10px}>
                    <Grid container spacing={1} className={classes.optionsRow}>
                        <Grid item md={6} className={cx(classes.variantOption)}>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <ProductBroken
                                    product={variant}
                                    size="small"
                                    className={cx(flexBox.relative, flexBox.top0, flexBox.left0)}
                                />
                                {variant.selectedOptions.map((option, idx) => (
                                    <span key={idx} className={cx(classes.variantRowSpan, classes.varOptText)}>
                                        {option.value + (variant.selectedOptions.length - 1 > idx ? ' / ' : '')}
                                    </span>
                                ))}
                            </Stack>
                        </Grid>
                        <Grid item md={2}>
                            <span className={classes.variantRowSpan}>
                                <span style={{ marginRight: '2px' }}>
                                    <NumericFormat
                                        value={variant.price}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={getSymbolFromCurrency(variant.currency)}
                                    />
                                </span>
                            </span>
                        </Grid>
                        <Grid item md={2}>
                            <span className={classes.variantRowSpan}>{variant.stock}</span>
                        </Grid>
                        <Grid item md={2} className={cx(classes.optionsRow, classes.positionEnd)}>
                            <Divider
                                className={classes.divider + ' ' + (showForm ? classes.dividerColor : '')}
                                orientation="vertical"
                            />
                            {!showForm &&
                                (readOnly ? (
                                    <VisibilityIcon
                                        onClick={(e) => {
                                            e.preventDefault();
                                            openForm(index);
                                        }}
                                    />
                                ) : (
                                    <EditIcon
                                        onClick={(e) => {
                                            e.preventDefault();
                                            openForm(index);
                                        }}
                                    />
                                ))}
                            {!readOnly && (
                                <DeleteIcon
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setShowForm(false);
                                        deleteVariant();
                                        openForm(-1);
                                    }}
                                />
                            )}
                        </Grid>
                    </Grid>
                </div>
            </div>
            {showForm && (
                <div className={classes.p10px}>
                    <ProductFormVariants
                        readOnly={readOnly}
                        options={options}
                        variant={variant}
                        variants={variants}
                        index={index}
                        setVariants={setVariants}
                        close={() => openForm(-1)}
                        formConfigProductVariant={formConfigProductVariant}
                        canEdit={canEdit}
                    />
                </div>
            )}
        </div>
    );
};

export default ProductFormVariantsRow;
